export default "__VITE_ASSET__CI9SQ8I5__"